import {
  List,
  Datagrid,
  TextField,
  EmailField,
  EditButton,
  FunctionField,
  Filter,
  TextInput,
  NumberField,
} from "react-admin";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const OutletFilter: React.FC = (props) => (
  <Filter {...props}>
    <TextInput label="Code interne" source="internalCode" alwaysOn />
    <TextInput label="Nom de l'exutoire" source="name" alwaysOn />
    <TextInput label="Adress" source="address" alwaysOn />
    <TextInput label="Courriel" source="email" alwaysOn />
  </Filter>
);

export const OutletList = () => (
  <List
    resource="outlets"
    filters={<OutletFilter />}
    title="Liste des exutoires"
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid rowClick="edit">
      <TextField source="internalCode" label="Code interne" />
      <TextField source="name" label="Nom" />
      <TextField source="address" label="Adresse" />
      <EmailField source="email" label="Courriel" />
      <NumberField
        source="fullBinsCount"
        label="Caisses pleines"
        textAlign="center"
        sortable={false}
      />
      <NumberField
        source="emptyBinsCount"
        label="Caisses vides"
        textAlign="center"
      />
      <EditButton label="Modifier" />
      <FunctionField
        label="Inventaire"
        render={(record) => (
          <Button
            component={Link}
            to={`/outlet-inventory/details/${record.id}`}
            variant="outlined"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            Voir
          </Button>
        )}
      />
    </Datagrid>
  </List>
);
